import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMG } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";

export const Story = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);
  return (
    <section ref={ref} data-testid="story-section" className="relative overflow-hidden bg-[#F2EAE1] py-20 sm:py-28">
      <div className="mx-auto grid max-w-[1400px] items-center gap-12 px-5 sm:px-8 lg:grid-cols-12">
        <div className="relative lg:col-span-5">
          <div className="aspect-[3/4] overflow-hidden rounded-[28px]">
            <motion.img style={{ y: y1, scale: 1.15 }} src={IMG.pour} alt="Hands holding a fresh carrot ginger juice" className="h-full w-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-7">
          <Reveal>
            <p className="eyebrow mb-6 text-[#C85A32]">From the juice bar to your counter</p>
            <blockquote className="font-display text-3xl font-light leading-[1.15] tracking-tight sm:text-4xl lg:text-5xl">
              “That late-afternoon light, a cold-pressed something in your hand. <span className="italic text-[#C85A32]">We bottled the feeling</span> — you just add fruit.”
            </blockquote>
            <p className="mt-6 text-sm text-[#6E6661]">— Golden Hour Press</p>
          </Reveal>
          <div className="mt-12 aspect-[16/9] overflow-hidden rounded-[28px]">
            <motion.img style={{ y: y2, scale: 1.15 }} src={IMG.friends} alt="Friends sharing cold pressed juice on a sunny patio" className="h-full w-full object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
};
